// import ProductAddToCartHOC from '@common/components/ProductAddToCartHOC';
// import ProductCards from '@common/components/ProductCards';
// import Product from '@common/models/Product';
// import { RootState } from '@common/store';
// import { addProductToCart, subtractProductFromCart } from '@common/store/cart/slice';
// import { FeaturesSliceType } from '@common/store/features/slice';
// import {
//   fetchProductDetailsRequest,
//   fetchProductReviewsRequest,
//   ProductDetailsSliceType,
// } from '@common/store/productDetails/slice';
// import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
// import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
// import { isBrowser } from '@common/utils';
// import history from '@common/utils/history';
// import QuickViewEventProduct from '@components/Event';
// import QuickViewProduct from '@components/Product';
// import Toasts from '@components/Toasts';
// import Close from '@images/Close.svg';
// import mZoom from '@images/mZoom.svg';
// import Image from '@lib/Image';
// import React, { useState } from 'react';
// import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';

import ProductCard from '@layouts/ProductList/ProductList7/ProductCard';

export default ProductCard;
